import type { EvalRunDetail } from '@sbc/domain-models/agents';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

function rate(passed: number, total: number): string {
  return total === 0 ? '—' : `${Math.round((passed / total) * 100)}%`;
}

export function formatUsd(value: number | null | undefined): string {
  return value === null || value === undefined ? '—' : `$${value.toFixed(4)}`;
}

export function ReplaySummary({ run }: { run: EvalRunDetail }) {
  const byCategory = run.summary?.byCategory ?? [];
  if (byCategory.length === 0) {
    return null;
  }
  const misses = run.tasks.filter((task) => !task.passed);
  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle className="text-base">By category</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="rounded-md border">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Category</TableHead>
                  <TableHead>Right</TableHead>
                  <TableHead>Right-rate</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {byCategory.map((entry) => (
                  <TableRow key={entry.category}>
                    <TableCell className="font-medium">{entry.category}</TableCell>
                    <TableCell className="tabular-nums">
                      {entry.passed}/{entry.total}
                    </TableCell>
                    <TableCell className="tabular-nums">
                      {rate(entry.passed, entry.total)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </CardContent>
      </Card>

      {misses.length > 0 && (
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Misses ({misses.length})</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="rounded-md border">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Case</TableHead>
                    <TableHead>Category</TableHead>
                    <TableHead>Reason</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {misses.map((task) => (
                    <TableRow key={task.id}>
                      <TableCell className="font-medium">{task.taskKey}</TableCell>
                      <TableCell>{task.category ?? '—'}</TableCell>
                      <TableCell className="text-sm whitespace-normal">
                        {task.outcomes
                          .filter((outcome) => !outcome.pass)
                          .map((outcome) => outcome.reason)
                          .join(' · ')}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </Card>
      )}
    </>
  );
}
